import $ from 'jquery';
import Velocity from 'velocity-animate';

function initSliderAnimations(sliderClass, slideClass, imageClass, slideDuration = 3000, slideDelay = 250, outDuration = 300) {
  const principleEasing =  [ 0.25, 0.1, 0.25, 1 ];
  const progressbar = $('.' + sliderClass + '__progress-fill');
  const slides = $('.' + slideClass + '');
  let currentSlide = slides.eq(0);
  let nextSlide = currentSlide.next();

  function animateStuff() {
    Velocity
      .animate(progressbar, {
        translateX: ['0%', '-100%'],
      }, {
        duration: slideDuration,
        easing: 'linear',
      }) // fill progress bar
      .then(() => {
        progressbar.css({ 'transform': 'translateX(-100%)' }); // empty progress bar

        Promise.all([ animateOut(), animateIn() ])
          .then(() => {
            currentSlide = nextSlide;
            nextSlide = nextSlide.next().length ? nextSlide.next() : slides.eq(0);

            setTimeout(animateStuff, slideDelay);
          });
      });
  }

  function animateOut() {
    let images = currentSlide.find('.' + imageClass);

    images.each((i, img) => {
      Velocity.animate(img, {
        translateY: ['-150px', '0px'],
        opacity: 0,
      }, {
        duration: outDuration,
        easing: principleEasing,
      });
    });

    // fade out
    return Velocity.animate(currentSlide, {
      opacity: 0
    }, {
      duration: outDuration,
      easing: principleEasing,
      display: 'none',
    });
  }

  function animateIn() {
    let images = nextSlide.find('.' + imageClass);

    images.each((i, img) => {
      Velocity.animate(img, {
        translateY: ['0px', '-150px'],
        opacity: 1,
      }, {
        duration: 1000,
        delay: img.getAttribute('data-custom-animation-in-delay') || 0,
        easing: principleEasing,
      });
    });

    // fade in
    return Velocity.animate(nextSlide, {
      opacity: 1
    }, {
      duration: 750,
      easing: principleEasing,
      display: 'block',
    });
  }

  setTimeout(animateStuff, slideDelay); // start the loop
}


export default initSliderAnimations;
